import React, { Component } from 'react'
import axios from 'axios'
import Notifier from '../aside/Notifier';
import ErrorNotifier from '../aside/ErrorNotifier';
import {Modal,Button} from 'react-bootstrap'


import { Form,FormGroup,Input,Label } from "reactstrap";
import {RS_API} from '../../utils/config'
import FormComponent from "../../common/FormComponent";
import {addApplyJobs,getApplyJobs} from "../../redux/action/jobs/apply_jobsAction"
import {getProfileInfo} from "../../redux/action/profileInfoAction"

import{
  Validator,
  submitValidator,
  valid,
  refresh,
  errors
} from "../../common/Validator"
import { connect } from 'react-redux';



// assigned Hr component
 class AddApplyJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      candidateStatus: "",
      joiningDate:"",
      jobType:this.props.jobType?this.props.jobType:"",
      sourcedBy:"",
      taggedBy:"",
      status:"",
      remarks:"",
      dateError:"",
      error:"",
      message:"",
      getReqType:[],
      getCandi:[]
    };
 
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this)
    this.getCandiStatus = this.getCandiStatus.bind(this)
    // this.getDataPrimSec = this.getDataPrimSec.bind(this)
  }

  // onSumbit function trigering
 onSubmit(e) {
 
    e.preventDefault();
    submitValidator(e.target);
   let data = {
    jobReqirementId:this.props.reqId,
    jobId:this.props.jobId,
    canInfoId:this.props.profile.data.id,
    canUserId: this.props.profile.data.canUserId,
    candidateStatus:this.state.candidateStatus ,
    joiningDate: this.state.joiningDate,
    remarks:this.state.remarks,
    candidateSource:"Apply",
    sourcedby:this.state.sourcedBy,
    // sourcedOn:this.state.sourcedOn,
    taggedBy:this.state.taggedBy,
    // taggedOn: this.state.taggedOn
    };

    if(valid){
   this.props.addApplyJobs(data,this.props.handleCloseModal)
    }
    else{
      
      this.setState({
        error: "Please enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
  onChange(e) {
    Validator(e.target);
     this.setState({
       [e.target.name]: e.target.value,
     });
     console.log(e.target.value);
   }

   componentDidMount(){
    this.props.getProfileInfo()
    this.getCandiStatus()
    this.getJobType()
    refresh()
    }

    getCandiStatus() {
      axios
        .get(`${RS_API}/v1/api/candidate-status/select`, { withCredentials: true })
        .then((res) => {
          console.log(res);
          this.setState({
            getCandi:res.data
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    }

    getJobType() {
      axios
        .get(`${RS_API}/v1/api/requirement-type/can`, { withCredentials: true })
        .then((res) => {
          console.log(res);
          this.setState({
            getReqType:res.data
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
 


  render() {
    console.log(this.props.profile.data)
   return (
     <div>
       <Modal
         size="lg"
         show={this.props.showPopUp}
         onHide={this.props.handleCloseModal}
       >
         <i
           data-toggle="tooltip"
           data-placement="top"
           title="Close"
           onClick={this.props.handleCloseModal}
           className="material-icons pointer cancel-button"
         >
           cancel
         </i>

         {/* <Form onSubmit={this.handleSubmitData} className="p-3 mt-2" noValidate> */}
         <div
           style={{
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             marginTop: "1rem",
           }}
         >
           <Modal.Title>Apply Jobs</Modal.Title>
         </div>

         <div style ={{width:"100%",display:"flex",justifyContent:"center"}}>
         
           <div style={{width:"50%"}}>
           <Form onSubmit={this.onSubmit} className="p-3" noValidate>
          
                         <FormGroup>
                         <Label  className="bold label-sm">
                              Candidate Status
                            </Label>
                            <Input
                             tabIndex="8"
                              style={{
                                height: "50px",
                               }}
                              type="select"
                              name="candidateStatus"
                              className="form-control-sm"
                              value={this.state.candidateStatus}
                              onChange={this.onChange}
                           
                              required={true}
                            >
                              <option value="" hidden>
                                Select...
                              </option>
                              {this.state.getCandi.map((item) => {
                                return (
                                  <option
                                    key={item.id}
                                    value={item.candidateStatus}
                                  >
                                    {item.candidateStatus}
                                  </option>
                                );
                              })}
                            </Input>
                            {errors.candidateStatus && (
                              <span style={{color:"red"}} className="error">
                                {errors.candidateStatus}
                              </span>
                            )}
                          </FormGroup>
                       

                <div
           style={{
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             marginTop:"1rem"
           }}
         >
           <Button  type="submit" variant="primary">Submit</Button>
         </div>
            </Form>
           </div>
         </div>

        
       </Modal>
       {this.props.ReferCandidate.message && <Notifier message={this.props.ReferCandidate.message} />}
       {this.props.ReferCandidate.error && <ErrorNotifier message={this.props.ReferCandidate.error} />}
            {this.state.error && <ErrorNotifier message={this.state.error} />}
     </div>
   );
  }
}
const mapStateToProps = (state) => ({
  ReferCandidate: state.ReferCandidate,
  profile: state.profile,
});


export default connect(mapStateToProps,{
    addApplyJobs,
    getProfileInfo,
    getApplyJobs
})(AddApplyJobs)





